<template>
  <VpVueForm
    :fields="fields"
    :id="id"
    class="vp-p-6"
    :save="save"
    :get="get"
    :del="archive"
    width="400px"
    ref="item"
    #default="{ state }"
    collection-cache="cardSocialLinks"
    feature="CARDS"
  >
    <VpField rules="required" label="Platform" name="Platform">
      <social-platforms v-model="state.platform" />
    </VpField>

    <VpField rules="required|url" label="URL" name="URL">
      <VpInput>
        <VpTextBox
          v-model="state.url"
          placeholder="https://www.twitter.com/VepaarHQ"
        />
      </VpInput>
    </VpField>
  </VpVueForm>
</template>

<script>
import deleteLink from "./delete.gql";
import get from "./get.gql";
import upsert from "./upsert.gql";

import SocialPlatforms from "./_social-platforms.vue";

export default {
  props: {
    id: [Number, String],
    cardId: [Number, String],
  },
  components: {
    SocialPlatforms,
  },
  data() {
    return {
      fields: ["id", "platform", "url"],
    };
  },

  methods: {
    get(id) {
      return this.$query(get, {
        id: id,
        cardId: Number(this.cardId),
      }).then((res) => {
        return {
          values: res.data.cardSocialLink,
          res,
        };
      });
    },

    save(id, data) {
      return this.$mutate(upsert, {
        cardId: Number(this.cardId),
        input: {
          id,
          ...data,
        },
      }).then(({ data }) => {
        this.$router.push({ name: "social-links" });
        return data;
      });
    },

    archive(id, action) {
      return this.$mutate(deleteLink, {
        cardId: Number(this.cardId),
        id: parseInt(id),
        action,
      }).then(() => {
        this.$router.push({ name: "social-links" });
      });
    },
  },
};
</script>
